import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  IconButton,
  Divider,
} from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import { useLanguage } from '../contexts/LanguageContext';

const Footer: React.FC = () => {
  const { t } = useLanguage();

  return (
    <Box
      sx={{
        backgroundColor: '#1A2332',
        color: 'white',
        py: { xs: 6, md: 8 },
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={{ xs: 4, md: 6 }}>
          <Grid size={{ xs: 12, md: 6 }}>
            <Typography
              variant="h4"
              sx={{
                mb: 2,
                fontWeight: 600,
                fontSize: { xs: '1.5rem', md: '2rem' },
                color: '#6DABE4',
              }}
            >
              Onionshack
            </Typography>
            <Typography
              variant="h6"
              sx={{
                mb: 3,
                fontSize: { xs: '1rem', md: '1.25rem' },
                fontWeight: 400,
                color: '#B0BEC5',
              }}
            >
              {t.footer.tagline}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: '#90A4AE',
                lineHeight: 1.6,
                fontSize: { xs: '0.875rem', md: '1rem' },
                maxWidth: '400px',
              }}
            >
              {t.footer.description}
            </Typography>
          </Grid>

          <Grid size={{ xs: 12, md: 6 }}>
            <Grid container spacing={4}>
              <Grid size={6}>
                <Typography
                  variant="h6"
                  sx={{
                    mb: 3,
                    fontWeight: 600,
                    fontSize: { xs: '1rem', md: '1.125rem' },
                    color: '#E0E0E0',
                  }}
                >
                  {t.footer.services.title}
                </Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  {t.footer.services.list.map((service) => (
                    <Typography
                      key={service}
                      variant="body2"
                      sx={{
                        color: '#90A4AE',
                        fontSize: { xs: '0.8rem', md: '0.875rem' },
                        cursor: 'pointer',
                        transition: 'color 0.3s ease',
                        '&:hover': {
                          color: '#6DABE4',
                        },
                      }}
                    >
                      {service}
                    </Typography>
                  ))}
                </Box>
              </Grid>

              <Grid size={6}>
                <Typography
                  variant="h6"
                  sx={{
                    mb: 3,
                    fontWeight: 600,
                    fontSize: { xs: '1rem', md: '1.125rem' },
                    color: '#E0E0E0',
                  }}
                >
                  {t.footer.contact.title}
                </Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  <Typography
                    variant="body2"
                    sx={{
                      color: '#90A4AE',
                      fontSize: { xs: '0.8rem', md: '0.875rem' },
                    }}
                  >
                    {t.contact.phone}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      color: '#90A4AE',
                      fontSize: { xs: '0.8rem', md: '0.875rem' },
                    }}
                  >
                    {t.contact.email}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      color: '#90A4AE',
                      fontSize: { xs: '0.8rem', md: '0.875rem' },
                    }}
                  >
                    www.onionshack.com
                  </Typography>
                </Box>
              </Grid>
            </Grid>

            <Box sx={{ mt: 4, display: 'flex', gap: 1 }}>
              <IconButton
                component="a"
                href="https://www.facebook.com/onionshack"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                sx={{
                  color: '#90A4AE',
                  backgroundColor: 'rgba(255, 255, 255, 0.05)',
                  '&:hover': {
                    color: '#6DABE4',
                    backgroundColor: 'rgba(109, 171, 228, 0.15)',
                  },
                }}
              >
                <FacebookIcon />
              </IconButton>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ my: 4, backgroundColor: 'rgba(255, 255, 255, 0.1)' }} />

        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: '#90A4AE',
              fontSize: { xs: '0.8rem', md: '0.875rem' },
            }}
          >
            {t.footer.copyright}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: '#90A4AE',
              fontSize: { xs: '0.8rem', md: '0.875rem' },
            }}
          >
            {t.footer.taxId}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;